<ng-container *ngIf="!(assignmentScheduleStateService.unansweredAssignmentSchedulesSubject | async)">
    <app-spinner></app-spinner>
</ng-container>


<ng-container
    *ngIf="assignmentScheduleStateService.unansweredAssignmentSchedulesSubject | async as assignmentSchedules">
    <app-assignment-schedules-list [assignmentSchedules]="assignmentSchedules">
    </app-assignment-schedules-list>
</ng-container>